import React, { useState } from 'react';
import {
    Autocomplete,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
    Paper,
    Switch,
    Tab,
    TextField,
} from '@mui/material'
import Cancel from './../../../../assets/icons/close.png'
import Typography from '@mui/material/Typography'
import AutoCompleteMultiSelect from '../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx';
import TextAreaComponents from '../../../components/TextAreaComponents/TextAreaComponents.tsx';

function ImportItemView(props) {
    const handleClose = () => {
        props.onHandleAddItem(false)
    }

    const menuDatas = [
        { id: 1, title: 'In Store Menu' },
        { id: 2, title: 'Online' },
        { id: 3, title: 'Offer' },
    ]

    const sectionDatas = [
        { id: 1, title: 'Chicken' },
        { id: 2, title: 'Burger' },
        { id: 3, title: 'Curry' },
        { id: 4, title: 'Soup' },
        { id: 5, title: 'Fries' },
    ]
    const restDatas = [
        { id: 1, title: 'PKB london' },
        { id: 2, title: 'PKB Manchester' }
    ]
    const [itemVal, setitemVal] = useState();
    const addValue = (props) => {
        console.log(props)
        setitemVal(props);
    }
    const [restaurantVal, setRestaurantVal] = useState();
    const restaurantValue = (props) => {
        console.log(props)
        setRestaurantVal(props);
    }
    const [sectionVal, setsectionVal] = useState();
    const sectionValue = (props) => {
        console.log(props)
        setsectionVal(props)
    }
    const textFieldValue = (props) => {
        console.log(props)
    }
    const saveData = () => {
        let value = {
            restaurant: restaurantVal,
            section: sectionVal,
            item: itemVal
        }
        props.onHandleAddItem(value);
    }
    return (
        <div>
            <React.Fragment>
                <Dialog
                    fullWidth={true}
                    maxWidth={'lg'}
                    open={props.open}
                    onClose={handleClose}
                >
                    <Grid container>
                        <Grid item xs={6}>
                            <DialogTitle>Import Item </DialogTitle>
                        </Grid>
                        <Grid item xs={6}>
                            <DialogActions>
                                <Button onClick={handleClose}>
                                    <img src={Cancel} alt="Close" style={{ width: '1.2rem' }} />
                                </Button>
                            </DialogActions>
                        </Grid>
                    </Grid>
                    <DialogContent style={{ backgroundColor: '#f3f0f3' }}>
                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Restaurant Name
                                </Typography>
                            </Grid>
                            <Grid item xs={10} style={{ paddingTop: '1rem' }}>
                                <AutoCompleteMultiSelect
                                    label={"Restaurant Name"}
                                    placeholder={'Restaurant Name'}
                                    value={restaurantValue}
                                    datas={restDatas}
                                    id={1}
                                />

                            </Grid>
                        </Grid>
                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Main Section Name
                                </Typography>
                            </Grid>
                            <Grid item xs={10} style={{ paddingTop: '1rem' }}>
                                <AutoCompleteMultiSelect
                                    label={"Main Section Name"}
                                    placeholder={'Main Section Name'}
                                    value={sectionValue}
                                    datas={menuDatas}
                                    id={1}
                                />

                            </Grid>
                        </Grid>
                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Item Name
                                </Typography>
                            </Grid>
                            <Grid item xs={10} style={{ paddingTop: '1rem' }}>
                                <AutoCompleteMultiSelect
                                    label={"Item Name"}
                                    placeholder={'Item Name'}
                                    value={addValue}
                                    datas={sectionDatas}
                                    id={1}
                                />

                            </Grid>
                        </Grid>
                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid item xs={8}></Grid>
                            <Grid item xs={2}>
                                {/* <Button className="AddItemButtons">Preview</Button> */}
                            </Grid>
                            <Grid item xs={2}>
                                <div className='d-flex justify-content-end'
                                >
                                    <Button className="AddItemButtons" onClick={() => saveData()}>Save</Button>
                                </div>

                            </Grid>
                        </Grid>

                    </DialogContent>
                    {/* <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions> */}
                </Dialog>
            </React.Fragment>
        </div>
    );
}

export default ImportItemView;